import React from 'react'
import ReactDOM from 'react-dom';
import FrontEndTable from "./components/TableFormatter";

const fieldInstanceIds = {};

function getTableFieldData() {
  document.querySelectorAll('.data-table').forEach((element) => {
    fieldInstanceIds[element.getAttribute('id')] = {
      'id': element.getAttribute('id'),
      'title': element.getAttribute('data-title'),
      'subtitle': element.getAttribute('data-subtitle'),
      'data': JSON.parse(element.getAttribute('data-table-json')),
      'site': element.getAttribute('data-site'),
      'variant': element.getAttribute('data-theme'),
    }
  })
}

function render() {
  getTableFieldData();

  Object.entries(fieldInstanceIds).forEach(([key, value]) => {
    const {id, title, subtitle, data, site, variant} = value;
    const exportData = structuredClone(data);

    ReactDOM.render(
      <div>
        <FrontEndTable title={title} subtitle={subtitle} data={data} site={site} variant={variant}
                       exportData={exportData}></FrontEndTable>
      </div>,
      document.getElementById(id)
    )
  })

}

render();
